export default __webpack_public_path__ + "static/media/3d-phone2.d52289ef.webp";